<template>
  <div>
    <div class="page_top">
      <div class="sechout">
        <div class="sech-left" @click="back()">
          <van-icon name="arrow-left" color="#ffffff" size="20" style="padding-left:16px" />
        </div>
        <div class="sech-title">便民电话</div>
        <div class="sech-right"></div>
      </div>
      <van-row type="flex" justify="center">
        <van-col span="22">
          <div>
            <div class="sech">
              <van-icon name="search" color="#00C459" size="20" />
            </div>
          </div>
        </van-col>
      </van-row>

    </div>
    <div class="content">
      <van-row type="flex" justify="center">
        <van-col span="22">
          <div>
            <div class="phone_item">
              <div class="phone_item_left">
                <div class="phone_item_left_num">18932932323</div>
                <div class="phone_item_left_name">水工电话</div>
              </div>
              <img class="call_icon" src="../../../../assets/house/property/call_icon.png" alt="">
            </div>
            <div class="phone_item">
              <div class="phone_item_left">
                <div class="phone_item_left_num">18932932323</div>
                <div class="phone_item_left_name">水工电话</div>
              </div>
              <img class="call_icon" src="../../../../assets/house/property/call_icon.png" alt="">
            </div>
            <div class="phone_item">
              <div class="phone_item_left">
                <div class="phone_item_left_num">18932932323</div>
                <div class="phone_item_left_name">水工电话</div>
              </div>
              <img class="call_icon" src="../../../../assets/house/property/call_icon.png" alt="">
            </div>
            <div class="phone_item">
              <div class="phone_item_left">
                <div class="phone_item_left_num">18932932323</div>
                <div class="phone_item_left_name">水工电话</div>
              </div>
              <img class="call_icon" src="../../../../assets/house/property/call_icon.png" alt="">
            </div>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      back() {
        this.$router.go(-1);
      },
    }
  }
</script>

<style lang="less" scoped>
  .page_top {
    height: 162px;
    background: #26C165;
  }

  .sechout {
    padding-top: 22px;
    margin-bottom: 16px;
    height: 44px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .sech-left,
  .sech-right {
    width: 104px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .sech-title {
    font-size: 17px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 28px;
  }

  .page_top_title {
    padding-left: 20px;
    margin-top: 14px;
    font-size: 24px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 24px;
  }

  .sech {
    margin-top: 16px;
    height: 36px;
    background: #FFFFFF;
    border-radius: 18px;
    opacity: 0.6;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .content {
    background: #fff;
    padding-top: 20px;
    transform: translateY(-12px);
    border-radius: 12px 12px 0px 0px;
  }

  .phone_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 79px;
    border-bottom: 1px solid #E2E6E7;
  }

  .phone_item_left {}

  .phone_item_left_num {
    font-size: 18px;
    font-weight: 500;
    color: #222325;
    line-height: 25px;
    margin-bottom: 4px;
  }

  .phone_item_left_name {
    font-size: 13px;
    font-weight: 400;
    color: #6D7177;
    line-height: 18px;
  }

  .call_icon {
    width: 32px;
  }
</style>